module.exports = __webpack_public_path__ + "img/answerline.761afa13.svg";